import { Controller } from "@hotwired/stimulus";
import Coloris from "@melloware/coloris";

export default class extends Controller {
  static values = {
    selector: String,
    swatches: { type: Array, default: [] },
  };

  connect() {
    if (!document.getElementById("clr-picker")) {
      Coloris.init();
      const picker = document.getElementById("clr-picker");
      if (picker) picker.setAttribute("data-turbo-permanent", "");
    }
    this.bind();
    document.addEventListener("turbo:morph", this.bind);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.bind);
  }

  bind = () => {
    Coloris({
      el: this.selectorValue,
      format: "hex",
      alpha: false,
      themeMode: "auto",
      formatToggle: false,
      swatches: this.swatchesValue,
    });
  };
}
